// startup
// Load entry module and return exports
// This entry module depends on other loaded chunks and execution need to be delayed
var __webpack_exports__ = __webpack_require__.O(undefined, ["blocks/marine-card-days/style-view","blocks/weather-ten-days-card/style-view"], () => (__webpack_require__("./src/blocks/weather-ten-days-card/view.js")))
__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
